"use client";

export default function GlobalError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="cs">
      <body
        style={{
          margin: 0,
          backgroundColor: "#FBFAF7",
          color: "#0C2340",
          fontFamily: "system-ui, sans-serif",
        }}
      >
        <div style={{ maxWidth: "640px", margin: "0 auto", padding: "96px 24px" }}>
          <p
            style={{
              fontFamily: "monospace",
              fontSize: "12px",
              letterSpacing: "0.12em",
              textTransform: "uppercase",
              color: "#7A5F2E",
              margin: 0,
            }}
          >
            Neočekávaná chyba
          </p>
          <h1 style={{ fontFamily: "Georgia, serif", fontSize: "2.25rem", margin: "24px 0 0" }}>
            Něco se nepovedlo
          </h1>
          <p style={{ marginTop: "16px", fontSize: "1.0625rem", lineHeight: 1.7, color: "#5B6B7B" }}>
            Stránku se nepodařilo zobrazit. Zkuste ji prosím načíst znovu.
          </p>
          <button
            type="button"
            onClick={() => reset()}
            style={{
              marginTop: "32px",
              minHeight: "48px",
              padding: "0 28px",
              borderRadius: "2px",
              border: "1px solid #0C2340",
              backgroundColor: "#0C2340",
              color: "#FFFFFF",
              fontSize: "0.9375rem",
              cursor: "pointer",
            }}
          >
            Zkusit znovu
          </button>
        </div>
      </body>
    </html>
  );
}
